module.exports = __webpack_public_path__ + "static/todoist_2-adebf5cb549dc8a8b4974ead9d0e5110.png";